import React from 'react';
import './About.css';

const WHY_POINTS = [
  'Premium hand-selected materials',
  'Built for UK playing conditions',
  'Professional-grade finishing',
  'Custom design options',
  'Designed for durability & consistency',
];

/** Social profile URLs */
const SOCIAL_TIKTOK = 'https://www.tiktok.com/@usl464018';
const SOCIAL_INSTAGRAM = 'https://www.instagram.com/AJ_15.06/';
const SOCIAL_FACEBOOK = 'https://www.facebook.com/share/1bNapzJzED/';

function IconTikTok() {
  return (
    <svg className="about-social-icon-svg" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 15.77 6.34 6.34 0 0011.63 22a6.34 6.34 0 006.38-6.33V6.69h-.42z"
      />
    </svg>
  );
}

function IconInstagram() {
  return (
    <svg className="about-social-icon-svg" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
      />
    </svg>
  );
}

function IconFacebook() {
  return (
    <svg className="about-social-icon-svg" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
      />
    </svg>
  );
}


const About = ({ onNavigate }) => {
  const go = (view) => {
    if (typeof onNavigate === 'function') onNavigate(view);
  };

  return (
    <div className="about-page-usl">
      <section className="about-hero-usl">
        <div className="about-hero-bg" />
        <div className="about-hero-inner">
          <div className="about-hero-image-col">
            <div className="about-hero-img-wrapper">
              <div className="about-hero-gold-glow" />
              <img
                src="/images/about1.png"
                alt="Universal Sports Lab cricket bats"
                className="about-hero-img"
              />
            </div>
          </div>

          <div className="about-hero-copy">
            <p className="about-hero-kicker">Universal Sports Lab</p>
            <h1 className="about-hero-headline">
              <span className="about-hero-line1">Engineered for Champions.</span>
              <span className="about-hero-line2">Built for Every Player.</span>
            </h1>
            <p className="about-hero-sub">
              At Universal Sports Lab, we design and craft high-performance cricket gear that blends
              precision engineering with elite-level quality.
            </p>
            <div className="about-hero-ctas">
              <button type="button" className="about-btn about-btn-primary" onClick={() => go('products')}>
                Shop Bats
              </button>
              <button type="button" className="about-btn about-btn-ghost" onClick={() => go('kit-designer')}>
                Customise Your Gear
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="about-why-usl">
        <div className="about-container">
          <div className="about-why-header">
            <h2 className="about-why-title">Why Choose Universal Sports Lab</h2>
            <p className="about-why-lead">
              We don&apos;t just make equipment — we build performance tools.
            </p>
          </div>
          <ul className="about-why-list">
            {WHY_POINTS.map((text) => (
              <li key={text} className="about-why-item">
                <span className="about-why-dot" aria-hidden="true" />
                <span>{text}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="about-social-usl" aria-labelledby="about-social-heading">
        <div className="about-container">
          <div className="about-social-header">
            <h2 id="about-social-heading" className="about-social-title">
              Follow us
            </h2>
            <p className="about-social-sub">
              Clips, drops, and kit culture — join the community on TikTok and Instagram.
            </p>
          </div>
          <div className="about-social-grid">
            <a
              className="about-social-card about-social-card--tiktok"
              href={SOCIAL_TIKTOK}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="about-social-card-icon" aria-hidden="true">
                <IconTikTok />
              </span>
              <span className="about-social-card-body">
                <span className="about-social-card-label">TikTok</span>
                <span className="about-social-card-handle">@usl464018</span>
                <span className="about-social-card-cta">Watch on TikTok</span>
              </span>
              <span className="about-social-card-arrow" aria-hidden="true">
                →
              </span>
            </a>
            <a
              className="about-social-card about-social-card--instagram"
              href={SOCIAL_INSTAGRAM}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="about-social-card-icon" aria-hidden="true">
                <IconInstagram />
              </span>
              <span className="about-social-card-body">
                <span className="about-social-card-label">Instagram</span>
                <span className="about-social-card-handle">@AJ_15.06</span>
                <span className="about-social-card-cta">View on Instagram</span>
              </span>
              <span className="about-social-card-arrow" aria-hidden="true">
                →
              </span>
            </a>
            <a
              className="about-social-card about-social-card--facebook"
              href={SOCIAL_FACEBOOK}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="about-social-card-icon" aria-hidden="true">
                <IconFacebook />
              </span>
              <span className="about-social-card-body">
                <span className="about-social-card-label">Facebook</span>
                <span className="about-social-card-handle">Universal Sports Lab</span>
                <span className="about-social-card-cta">Follow on Facebook</span>
              </span>
              <span className="about-social-card-arrow" aria-hidden="true">
                →
              </span>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
